import { getSdpTenantName } from "@/helpers/getSdpTenantName";
import { keycloakAuthState } from "@/helpers/keycloakAuthState";


/**
 * Build auth headers for API requests, handling both Keycloak and legacy modes.
 * In Keycloak mode: no Authorization header (Istio handles auth via cookies).
 * In legacy mode: includes Authorization: Bearer {token}.
 */
export const buildAuthHeaders = (
  token: string,
  organizationName?: string,
): Record<string, string> => {
  const headers: Record<string, string> = {
    "SDP-Tenant-Name": getSdpTenantName(organizationName),
  };

  if (!keycloakAuthState.isKeycloakMode && token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};

/**
 * Get the `credentials` option for fetch requests.
 * In Keycloak mode: "include" to send cookies.
 * In legacy mode: undefined (default).
 */
export const getAuthCredentials = (): RequestCredentials | undefined => {
  return keycloakAuthState.isKeycloakMode ? "include" : undefined;
};
